"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Accordion_1 = require("./Accordion");
const { root } = Accordion_1.accordionSummaryClasses;
const MuiAccordionSummaryOverrides = {
    MuiAccordionSummary: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`&.${root}`]: { minHeight: 34, margin: '0px', paddingX: '1rem' },
                [`&.${root}.hoverEffect:hover`]: { backgroundColor: theme.palette.gray[100] },
                [`&.${root}.noHover:hover`]: { cursor: 'default' },
            }),
            content: ({ theme }) => ({
                fontSize: theme.typography.body1.fontSize,
                fontWeight: theme.typography.fontWeightBold,
                fontFamily: 'proxima-nova',
                margin: '8px 0px',
                lineHeight: 1.5,
            }),
        },
    },
};
exports.default = MuiAccordionSummaryOverrides;
//# sourceMappingURL=AccordionSummaryOverrides.js.map